<div class="config-container shadow my-3" *ngFor="let plan of plans">
  <h4 class="title configurator-subtitle collapse-button" (click)="togglePlanCollapse(plan.displayOrder)">
    {{ 'workbench.splashback.plan-number' | translate }} {{ plan.displayOrder }}
  </h4>

  <div class="collapse-block" *ngIf="selectedPlanIndex === plan.displayOrder">
    <div class="config-container shadow my-3" *ngFor="let splashback of plan.configurationSplashbacks">
      <h4
        class="title configurator-subtitle collapse-button"
        (click)="toggleSplashbackCollapse(splashback.displayOrder)">
        {{ 'workbench.splashback.splashback-number' | translate }} {{ splashback.displayOrder }}
      </h4>

      <div class="collapse-block" *ngIf="selectedSplashbackIndex === splashback.displayOrder">
        <button class="cutting-add-button" (click)="addSplashbackConfigurationCutting(splashback.displayOrder)">
          + {{ 'workbench.splashback.cutting.add' | translate }}
        </button>

        <div
          class="config-container shadow my-3"
          *ngFor="let splashbackCutting of splashback.configurationCuttings; let index = index">
          <h4
            class="title configurator-subtitle collapse-button"
            (click)="toggleCuttingCollapse(splashbackCutting.displayOrder)">
            {{ 'workbench.splashback.cutting.cutting-number' | translate }} {{ splashbackCutting.displayOrder }}
          </h4>

          <div class="collapse-block" *ngIf="selectedSplashbackCuttingIndex === splashbackCutting.displayOrder">
            <div class="container-fluid">
              <div class="row">
                <div class="configurator-cards-container">
                  <div
                    class="configurator-card"
                    *ngFor="let cutting of cuttings"
                    [ngClass]="{ active: isCuttingSelected(splashback.displayOrder, cutting.id) }"
                    (click)="selectCutting(cutting, splashback.displayOrder)">
                    <ng-casto-img-loader
                      [imgSrc]="workbenchService.apiUrl + cutting.icon.path"
                      [imgClass]="'configurator-card-img'">
                    </ng-casto-img-loader>
                    <p class="configurator-card-title">{{ cutting.name }}</p>
                  </div>
                </div>
                <ng-casto-loader *ngIf="cuttings === null"></ng-casto-loader>
              </div>

              <div class="cutting-delete align-right" *ngIf="cuttings != null">
                <button (click)="deleteCutting(splashback.displayOrder, index)" class="cutting-delete-button">
                  <svg>
                    <use
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xlink:href="assets/img/icons.svg#icon-action-delete"></use>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
